import axios from 'axios';

export const getCustomerType = () => {
  return axios
    .get(`/api/v1/customer/types`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      console.log('response', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveType = (name: any) => {
  return axios
    .post(
      `/api/v1/customer/types`,
      {
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      console.log('create type', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const editType = (cust_id: number, name: any) => {
  return axios
    .put(
      `/api/v1/customer/types/${cust_id}`,
      {
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      console.log('edit response', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteCustomertypes = (client_type_list: any) => {
  return axios
    .post(
      `/api/v1/delete/customer/types`,
      {
        client_type_list: client_type_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      console.log('delete response', response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
